<template>
  <PopupTemplate @close="closeCuponAmigoPdte()">
    <div class="contenidoInfoCuponPendiente">
      <div class="cabecera">¡Trae un amigo!</div>
      <div class="divCuponAmigo">
        <p
          id="codigoCupon"
          class="cuponAmigoPendiente"
          @click="copyToClipboard"
        >
          {{ cupon.cupon }}
        </p>
        <a
          v-if="cupon.pendiente && esMovil"
          v-bind:href="url"
          data-action="share/whatsapp/share"
          @click="insertAudit"
        >
          <fai :icon="['fab', 'whatsapp']" class="botonWhatsapp" />
        </a>
        <a v-if="cupon.pendiente && !esMovil" @click="copyToClipboard">
          <fai :icon="['far', 'copy']" class="botonCopy" />
        </a>
      </div>
      <p>
        Comparte este cupón descuento con un familiar o amigo y le daremos la 
        bienvenida como nuevo cliente
      </p>
      <ul>
          <li>
            <b> 20% dto. para un seguro de auto </b> contratando en oficinas y 
              10% dto. si lo contrata por canal telefónico
            </li>    
            <li>
             <b> 10% dto. para un seguro de hogar, negocio, mascota, bicicleta...</b>
            </li>
      </ul>
     <p>
      Cuando contrate tu amigo... <b> tendrás el mismo descuento que él en la renovación de tu póliza</b>
      , acumulando descuentos hasta un máximo del 40% por póliza y año.
     </p>
    </div>
  </PopupTemplate>
</template>

<script>
import { isMobile } from "react-device-detect";
/* eslint-disable no-console */
export default {
  props: {
    cuponInic: { type: String, required: true, default: null }
  },

  data() {
    return {
      cupon: this.cuponInic,
      url: null,
      esMovil: true
    };
  },

  created() {
    console.log(this.cuponInic);
    const mensaje =
      "Con este código " + this.cupon.cupon + " y por ser nuevo cliente, MMT Seguros te aplica:\n\n" +
      "- 20% dto. para un seguro de auto contratando en oficinas y 10% dto. si lo contrata por canal telefónico.\n" +
      "- 10% dto. para un seguro de hogar, negocio, mascota, bicicleta...\n\n" +
      "Infórmate en una de nuestras oficinas: https://www.mmtseguros.com/atencion-cliente/contacto/#oficinas";
    this.url = "whatsapp://send?text=" + encodeURIComponent(mensaje);
    this.esMovil = isMobile;
  },

  methods: {
    closeCuponAmigoPdte() {
      this.$emit("closeInfoCuponAmigo");
    },
    copyToClipboard() {
      console.log("COPYTOCLIPBOARD");
      this.$toasted.show("Copiado al portapapeles", {
        theme: "bubble",
        position: "bottom-center",
        duration: 1500
      });
      this.$clipboard(this.cupon.cupon);
      this.$store.dispatch("insertAudit", {
        idCliente: this.$store.state.portfolio.cliente.idCliente,
        nif: this.$store.state.portfolio.cliente.numDoc,
        nameEvento: "CUPON_AMIGO_COMPARTE_CODIGO",
        info: this.$store.state.portfolio.cliente.idCliente
      });
    },
    insertAudit() {
      this.$store.dispatch("insertAudit", {
        idCliente: this.$store.state.portfolio.cliente.idCliente,
        nif: this.$store.state.portfolio.cliente.numDoc,
        nameEvento: "CUPON_AMIGO_COMPARTE_CODIGO",
        info: this.$store.state.portfolio.cliente.idCliente
      });
    }
  }
};
</script>

<style lang="scss">
@media screen and (max-width: 480px) {
  // el popup se ajusta al contenido y lleva 2rem de padding a cada lado. Con esto el popup ocupa ~92% del ancho de pantalla en movil
  .contenidoInfoCuponPendiente {
    width: calc(92vw - 4rem);
  }
}

.cuponAmigoPendiente {
  background-color: white;
  width: 70%;
  font-weight: bold;
  color: $azulOscuroMMT;
  border-radius: 0.5rem;
  border: $azulOscuroMMT 0.15rem solid;
  text-align: center;
  margin-right: 0.5rem;
  display: inline-block;
  cursor: pointer;
}

.divCuponAmigo {
  width: 15rem;
  display: inline-block;
  text-align: center;
}

.cabecera {
  font-size: 120%;
  margin-bottom: 1rem;
  color: $colorMMT;
  border-bottom: 2px solid $azulOscuroMMT;
}

.botonWhatsapp {
  color: green;
  font-size: 1.4rem;
  display: inline-block;
}

.botonCopy {
  color: #82c91e;
  font-size: 1.4rem;
  display: inline-block;
  cursor: pointer;
}
</style>
